<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>国际商务模拟教学平台</span>
        <b>INTERNATIONAL BUSINESS SIMULATION TEACHING PLATFORM</b>
      </div>
      <div class="mainbody">
        <div class="setionbox">
          <p>
            《国际商务教学模拟平台》主要模拟国际贸易交易的整个流程，其中包括多种支付（信用证L/C、汇付和托收
            ）和多种运输方式（FOB、CIF、CFR、EXWORK ）等的模拟，
            给学生提供一个全过程的教学实践模拟平台，为教师提供多种辅助教学手段，提高学生的专业水平和社会实践能力，为将来投入社会工作奠定更好的基础，争取更大的就业机会。
          </p>
        </div>
        <div class="setionbox">
          <div class="setiontop">
            <div class="left">
              <p>国际商务模拟教学平台</p>
              <div class="line"></div>
              <div class="text">
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 用户管理</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 业务流程模拟系统</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 系统维护</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 学生评分系统</p>
              </div>
            </div>
            <div class="right">
              <img
                style="width: 760px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/img1.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div>
              <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/img2.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>用户管理</span>
                <p>老师角色管理</p>
                <p>班级学生管理</p>
                <p>业务角色分配</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/img3.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>业务流程模拟系统</span>
                <p>进、出口业务管理</p>
                <p>货代业务管理</p>
                <p>船运、空运业</p>
                <p>银行业务管理</p>
                <p>综合业务管理</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/img4.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>系统维护</span>
                <p>营销管理过程</p>
                <p>模拟竞争</p>
                <p>营销模式实施</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 66px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/img5.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>学生评分系统</span>
                <p>网络营销技能</p>
                <p>网站营销训练</p>
                <p>网络营销训练</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>

            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'InternationalBusinessSimulationTeachingPlatform',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.setiontop {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    p {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .line {
      margin-top: 20px;
      width: 120px;
      height: 4px;
      background: #f39a21;
    }
    .text > p {
      width: 250px;
      margin-top: 35px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #1c43bd;
    }
  }
  .right {
    flex: 1;
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
    justify-content: space-around;
    align-items: center;

    div {
      width: 270px;
      background-color: #ffffff;
      // border: 1px solid #000;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 418px;
      position: relative;
      .transparent-line {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
      }

      .imgbox {
        flex: 1;
      }
      .underbox {
        flex: 1;
      }

      span {
        margin-top: 30px;
        margin-bottom: 29px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #1c43bd;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.mainbody > .setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1080px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/InternationalBusinessSimulationTeachingPlatform.vue